import * as a11y from '../vendor/theme-scripts/theme-a11y';

const selectors = {
  body: 'body',
  popdownTrigger: 'data-popdown-toggle',
  close: '[data-popdown-close]',
  input: '[data-predictive-search-input]',
};

const classes = {
  isVisible: 'is-visible',
  focused: 'is-focused',
};

let sections = {};

class SearchPopdownTriggers {
  constructor(trigger) {
    this.trigger = trigger;
    this.key = this.trigger.getAttribute(selectors.popdownTrigger);

    const popdownSelector = `[id='${this.key}']`;
    this.document = document;
    this.popdown = document.querySelector(popdownSelector);
    this.input = this.popdown.querySelector(selectors.input);
    this.close = this.popdown.querySelector(selectors.close);
    this.body = document.querySelector(selectors.body);
    this.accessibility = a11y;

    this.initTriggerEvents();

    // Initialized once for every search trigger
    this.initPopdownEvents();
  }

  initTriggerEvents() {
    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);

    this.trigger.addEventListener('click', (evt) => {
      evt.preventDefault();

      if (!this.body.classList.contains(classes.focused)) {
        this.showPopdown();
      }
    });

    this.trigger.addEventListener('keyup', (evt) => {
      if ((evt.which === window.theme.keyboardKeys.SPACE || evt.which === window.theme.keyboardKeys.ENTER) && this.body.classList.contains(classes.focused)) {
        this.showPopdown();
      }
    });
  }

  initPopdownEvents() {
    this.popdown.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hidePopdown();
      }.bind(this)
    );

    this.close.addEventListener(
      'click',
      function () {
        this.hidePopdown();
      }.bind(this)
    );

    this.document.addEventListener('click', (event) => {
      const clickedElement = event.target;
      const isNotSearchExpandButton = !(clickedElement.matches(`[${selectors.popdownTrigger}]`) || clickedElement.closest(`[${selectors.popdownTrigger}]`));
      const isNotSearchPopdownChild = !(clickedElement.matches(`#${this.key}`) || clickedElement.closest(`#${this.key}`));

      if (isNotSearchExpandButton && isNotSearchPopdownChild && this.popdown.classList.contains(classes.isVisible)) {
        this.hidePopdown();
      }
    });
  }

  hidePopdown() {
    this.popdown.classList.remove(classes.isVisible);
    this.input.form.reset();
    this.input.dispatchEvent(new CustomEvent('clear', {bubbles: false}));
    this.accessibility.removeTrapFocus();
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

    if (this.body.classList.contains(classes.focused)) {
      setTimeout(() => {
        this.trigger.focus();
      }, 200);
    }
  }

  showPopdown() {
    document.dispatchEvent(
      new CustomEvent('theme:drawer:close', {
        bubbles: false,
      })
    );

    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.popdown}));

    this.popdown.classList.add(classes.isVisible);
    const popdownTransitionDuration = parseFloat(window.getComputedStyle(this.popdown).getPropertyValue('transition-duration')) * 1000;
    const val = this.input.value;
    this.input.value = '';
    this.input.value = val;

    setTimeout(() => {
      this.accessibility.trapFocus(this.popdown);
      this.input.focus();
    }, popdownTransitionDuration);
  }
}

const searchPopdown = {
  onLoad() {
    sections[this.id] = [];
    const triggers = this.container.querySelectorAll(`[${selectors.popdownTrigger}]`);
    triggers.forEach((el) => {
      sections[this.id].push(new SearchPopdownTriggers(el));
    });
  },
};

export default searchPopdown;
